define((require) => {
    "use strict";

    var _                     = require("underscore"),
        Action                = require("shared/ui/experience/action/Action"),
        ActionFactory         = require("shared/ui/experience/action/ActionFactory"),
        ActionHelper          = require("ui/experience/action/ActionHelper"),
        ActionsViewController = require("ui/experience/action/ActionsViewController"),
        ImprovedView          = require("editor/zbone/ImprovedView"),
        template              = require("ui/experience/action/ActionsView.tpl");

    /**
     * Actions drop down menu and associated properties below, dependinging on the selected action.
     *
     * @cfg {AbstractWidgetModel} model The widget being edited.
     *
     * @class ActionsView
     * @author Kim
     */
    return ImprovedView.extend({

        template: template,

        controller: ActionsViewController,

        initialize: function() {
            this.options = _.defaults(this.options, {
                onlyShowProductActions: false
            });

            if (this.model.get("type") === "text-enhanced") {
                this.listenTo(this.model, "change:text", this._handleETWTextChange);
            }
        },

        _handleETWTextChange(model) {
            const firstChild = ActionHelper.convertStringToHtml(model.get("text"));
            const isEmailModeEnabled = this.viewScope.viewModel.get("experience").get("emailModeEnabled");
            this.ui.actionsSelect.prop("disabled", firstChild && firstChild.querySelector("a") && !isEmailModeEnabled);
        },

        ui: {
            actionsSelect: ".actions-select"
        },

        regions: {
            actionRegion: ".action-region"
        },

        experienceModelBindings: {
            ".actions-select": {
                observe: "emailModeEnabled",
                updateModel: false,
                update: function($el, isEmailMode) {
                    const actionModel = this.model.get("action");
                    const actionIdentifier = actionModel ? actionModel.getIdentifier() : null;
                    if (isEmailMode && (!actionIdentifier || actionIdentifier.type !== "link")) {
                        this.model.set({action: null});
                        $el.trigger({type: "change.select2"});
                    }
                }
            }
        },

        bindings: {
            ".actions-select": {
                observe: "action",

                initialize: function($el) {
                    $el.select2({
                        placeholder: "Select an Action",
                        dropdownAutoWidth: true,
                        dropdownCssClass: "actions-select",
                        formatResult: function(state) {
                            return ActionHelper.getFormattedOption(state);
                        }
                    });

                    if (this.model.get("type") === "text-enhanced") {
                        this._handleETWTextChange(this.model);
                    }
                },

                selectOptions: {
                    labelPath: "label",
                    valuePath: "value",
                    defaultOption: {
                        label: "None",
                        value: null
                    },
                    collection: function() {
                        const isEmailModeEnabled = this.viewScope.viewModel.get("experience").get("emailModeEnabled");
                        return ActionHelper.getActionSelectOptionCollection(this.options.onlyShowProductActions, isEmailModeEnabled);
                    }
                },

                onGet: function() {
                    const actionModel = this.model.get("action");
                    return actionModel ? actionModel.getIdentifier() : null;
                },

                onSet: function(actionIdentifier) {
                    if (!actionIdentifier) {
                        return null;
                    }

                    var options = ActionHelper.getActionOptions(actionIdentifier);
                    var actionModel = ActionFactory.newActionFromType(actionIdentifier.type, options);
                    return actionModel;
                }
            },

            ".action-region": {
                observe: "action",
                // Stay away from the model
                updateModel: false,
                // Show the appropriate properties view
                // Note: This seems to be invoked also when action properties
                // changes, e.g. LinkAction#url.
                update: function(element, changedValue) {
                    if (changedValue instanceof Action) {
                        var type = changedValue.get("type");

                        if (type) {
                            var PropertiesView = ActionHelper.actionTypeToPropertiesViewMap.get(type);

                            // Ensure we update model and do not show the action region if SalesforceCommerce AddOn gets disabled.
                            if (ActionHelper.isActionEnabledForCompany(type)) {
                                this.actionRegion.show(new PropertiesView({
                                    model: this.model.get("action"),
                                    widget: this.model,
                                    experience: this.viewScope.viewModel.get("experience")
                                }));
                            } else {
                                this.model.set("action", null);
                            }
                        }
                    } else if (!this.model.has("action")) {
                        this.actionRegion.close();
                    }
                }
            }
        },
        onRender: function() {
            this.stickit(this.viewScope.viewModel.get("experience"), this.experienceModelBindings);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/ActionsView.js